"use strict";

exports.__esModule = true;
exports.getComponentPath = getComponentPath;
function getComponentPath(path) {
  return JSON.stringify(path);
}